// application.js
import "@hotwired/turbo-rails"
import Rails from "@rails/ujs"
import * as bootstrap from "bootstrap";
import "./controllers";
import "./bulk_route";
import "./notifications_bulk_actions";
import "./orders_manual_sent";
import "./sidebar";
import "./offcanvas_forms";
import { initAddressLocationFilter } from "./address_location_filter";
import { initProfileFeatureSearch } from "./profile_feature_search";
import { initDashboardLayout } from "./dashboard_layout";
import { initOccurrenceReasonsOrder } from "./occurrence_reasons_order";
import { initTwoFactorQrCode } from "./two_factor_qr_code";
import $ from "jquery"
import select2 from "select2/dist/js/select2.full"
import moment from "moment";
import "bootstrap-daterangepicker"
import Inputmask from "inputmask"

Rails.start()

window.$ = $
window.jQuery = $
select2(window, $)
window.moment = moment
window.bootstrap = bootstrap

$(function () {
  $('#daterange').daterangepicker({
    locale: {
      format: 'DD/MM/YYYY'
    }
  })
})

import { initMap, wireRoutesButton } from "./leaflet_map";

// Sem Turbo: use DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  console.log("app DOMContentLoaded"); // debug
  initAddressLocationFilter();
  initMap();
  wireRoutesButton(); // liga o botão Rotas ao fetch + offcanvas
  initProfileFeatureSearch();
  initDashboardLayout();
  initOccurrenceReasonsOrder();
  initTwoFactorQrCode();
});

// Toastr (mantém como já estava)
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".toast").forEach((toastEl) => {
    const toast = new bootstrap.Toast(toastEl, { delay: 4000 });
    toast.show();
  });
});

document.addEventListener("turbo:load", () => {
  initProfileFeatureSearch();
  initDashboardLayout();
  initOccurrenceReasonsOrder();
  initTwoFactorQrCode();
});

function initProfileSettingsModal() {
  const params = new URLSearchParams(window.location.search);
  const modalEl = document.getElementById("profileEditModal");
  if (!modalEl || !window.bootstrap) return;

  if (modalEl.dataset.profileTabsInitialized !== "true") {
    modalEl.addEventListener("show.bs.modal", () => {
      const section = modalEl.dataset.profileInitialSection || "account";
      const normalizedSection = section.charAt(0).toUpperCase() + section.slice(1);
      const tabButton = modalEl.querySelector(`[data-bs-target="#profileSettingsModal${normalizedSection}"]`);

      if (tabButton) {
        window.bootstrap.Tab.getOrCreateInstance(tabButton).show();
      }

      delete modalEl.dataset.profileInitialSection;
    });

    modalEl.dataset.profileTabsInitialized = "true";
  }

  if (params.get("profile_modal") !== "1") return;

  const section = params.get("profile_section");
  if (section) {
    modalEl.dataset.profileInitialSection = section;
  }

  window.bootstrap.Modal.getOrCreateInstance(modalEl).show();

  params.delete("profile_modal");
  params.delete("profile_section");

  const queryString = params.toString();
  const cleanUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""}${window.location.hash}`;
  window.history.replaceState({}, "", cleanUrl);
}

document.addEventListener("DOMContentLoaded", initProfileSettingsModal);
document.addEventListener("turbo:load", initProfileSettingsModal);

function initSessionTimeout() {
  const timeoutTag = document.querySelector('meta[name="session-timeout"]');
  const refreshUrlTag = document.querySelector('meta[name="session-refresh-url"]');
  const csrfTokenTag = document.querySelector('meta[name="csrf-token"]');
  const modalEl = document.getElementById("modal-timeout");
  const timeoutSeconds = Number.parseInt(timeoutTag?.content || "", 10);

  if (!timeoutTag || !modalEl || !Number.isFinite(timeoutSeconds) || timeoutSeconds <= 0) return;
  if (window.__sessionTimeoutInitialized) return;

  window.__sessionTimeoutInitialized = true;

  const sessionTimeout = timeoutSeconds * 1000;
  const refreshInterval = Math.min(Math.max(sessionTimeout / 2, 5000), 60000);
  let idleTimer;
  let lastSessionRefresh = 0;

  function showSessionExpiredModal() {
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl, {
      backdrop: "static",
      keyboard: false
    });

    modal.show();
  }

  function refreshSession() {
    const refreshUrl = refreshUrlTag?.content;
    const csrfToken = csrfTokenTag?.content;
    const now = Date.now();

    if (!refreshUrl || !csrfToken || now - lastSessionRefresh < refreshInterval) return;

    lastSessionRefresh = now;

    fetch(refreshUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest"
      }
    }).catch(() => {});
  }

  function resetIdleTimer() {
    if (modalEl.classList.contains("show")) return;

    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(showSessionExpiredModal, sessionTimeout);
    refreshSession();
  }

  ["mousemove", "keydown", "click", "scroll", "touchstart"].forEach((eventName) => {
    document.addEventListener(eventName, resetIdleTimer, { passive: true });
  });

  resetIdleTimer();
}

document.addEventListener("DOMContentLoaded", initSessionTimeout);
document.addEventListener("turbo:load", initSessionTimeout);

function initPlanUsageModal() {
  if (window.__planUsageModalInitialized) return;
  window.__planUsageModalInitialized = true;

  document.addEventListener("click", async (event) => {
    const trigger = event.target.closest("[data-plan-usage-modal-url]");
    if (!trigger) return;

    event.preventDefault();

    const url = trigger.dataset.planUsageModalUrl || trigger.href;
    if (!url) return;

    trigger.classList.add("disabled");
    trigger.setAttribute("aria-busy", "true");

    try {
      const response = await fetch(url, {
        credentials: "same-origin",
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      document.getElementById("planUsageModalHost")?.remove();
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
      document.body.classList.remove("modal-open");

      const host = document.createElement("div");
      host.id = "planUsageModalHost";
      host.innerHTML = html;
      document.body.appendChild(host);

      document.querySelectorAll(".flyout").forEach((panel) => panel.classList.remove("open"));
      document.querySelectorAll(".iconbtn[data-menu-target]").forEach((button) => button.classList.remove("with-arrow"));
      document.getElementById("flyoutBackdrop")?.classList.remove("show");
      document.getElementById("flyoutCap")?.classList.remove("show");

      const modalEl = host.querySelector("#planUsageDetailsModal");
      if (!modalEl) throw new Error("Modal nao encontrado");

      modalEl.addEventListener("hidden.bs.modal", () => {
        bootstrap.Modal.getInstance(modalEl)?.dispose();
        host.remove();
      }, { once: true });

      bootstrap.Modal.getOrCreateInstance(modalEl).show();
    } catch (error) {
      window.location.href = trigger.href;
    } finally {
      trigger.classList.remove("disabled");
      trigger.removeAttribute("aria-busy");
    }
  });
}

document.addEventListener("DOMContentLoaded", initPlanUsageModal);
document.addEventListener("turbo:load", initPlanUsageModal);
